import { GetSpacesRequest } from '@eggplant/api-requests'
import {
  Combobox,
  DropdownButton
} from '@eggplant/pattern-library'
import type {
  ButtonShape,
  GetSpacesResponse,
  Options
} from '@eggplant/types'
import { HiOutlineCube } from 'react-icons/hi'

interface Props {
  initialOptions?: Options
  onChange: (value: string) => void
  value: string
  isRequired?: boolean
  isDisabled?: boolean
  exclude?: string[]
  isWithIcon?: boolean
  optionPlaceholder?: string
}

const getOptions = (spaces: GetSpacesResponse) => spaces.map(space => ({
  label: space.name,
  value: space.id
}))

const SelectSpace = ({
  initialOptions = [],
  onChange,
  value,
  isRequired,
  isDisabled = false,
  exclude = [],
  isWithIcon = false,
  optionPlaceholder = 'Select a space'
}: Props) => {
  const handleChange = (value: string) => {
    onChange(value)
  }

  const getRenderButton = (spaces: GetSpacesResponse) => {
    const currentOption = spaces.find(item =>
      item.id === value
    )

    return (buttonProps: ButtonShape) =>
      <DropdownButton
        {...buttonProps}
        Icon={
          isWithIcon
            ? HiOutlineCube
            : undefined
        }
        isDisabled={isDisabled}
        label={
          currentOption?.id
            ? currentOption.name
            : undefined
        }
      >
        {
          currentOption
            ? currentOption.name
            : optionPlaceholder
        }
      </DropdownButton>
  }

  return (
    <GetSpacesRequest>
      {
        (spaces: GetSpacesResponse) => {
          const filteredSpaces = spaces.filter(space => !exclude.includes(space.id))

          return (
            <Combobox
              initialOptions={initialOptions}
              isRequired={isRequired}
              onChange={handleChange}
              options={getOptions(filteredSpaces)}
              renderButton={getRenderButton(filteredSpaces)}
              value={value}
            />
          )
        }
      }
    </GetSpacesRequest>
  )
}

export default SelectSpace
